"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagePropsPreview = exports.getPreviewPageProp = exports.PREVIEW_STATE_PROP = void 0;
const get_1 = __importDefault(require("lodash/get"));
const react_1 = require("react");
exports.PREVIEW_STATE_PROP = '_preview';
function getPreviewPageProp(pageProps) {
    return (0, get_1.default)(pageProps, ['props', exports.PREVIEW_STATE_PROP], (0, get_1.default)(pageProps, [exports.PREVIEW_STATE_PROP], false));
}
exports.getPreviewPageProp = getPreviewPageProp;
function usePagePropsPreview(pageProps) {
    return (0, react_1.useMemo)(() => getPreviewPageProp(pageProps), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getPreviewPageProp(pageProps)]);
}
exports.usePagePropsPreview = usePagePropsPreview;
//# sourceMappingURL=index.js.map